import { DataApi, FormatApi, SourceApi, TokenStorage } from '@chegg-wt/redux-citation-api'
import FakeDataApi from './fakeDataApi'

const Config = {
  dataUrl: 'https://data.playground.easybib.com',
  apiUrl: 'https://api.playground.citation-api.com',
  sourceBookUrl: 'https://proxy.writing.chegg.com/api/v1/citationSourceSearch/book',
  sourceArticleUrl: 'https://proxy.writing.chegg.com/api/v1/citationSourceSearch/journalCrossref',
  sourceWebsiteUrl: 'https://proxy.writing.chegg.com/api/v1/citationSourceSearch/website',
  autociteUrl: 'https://autocite.writing.chegg.com',
  autociteKey: 'e60618e2224a1dc22cd97f7f417f43db',
  apiKey: '20e6119d2c2eb7ed77b733900fb526d3',
}

export const tokenStorage = new TokenStorage({
  url: 'https://playground.easybib.com/auth/index/token',

  options: {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  },
})

// To use the original HTTP api:
// export const dataApi = new DataApi(Config.dataUrl, tokenStorage)
export const dataApi = new FakeDataApi(Config.dataUrl, tokenStorage)


export const formatApi = new FormatApi({
  format: { url: 'https://proxy.writing.chegg.com/2.1/rest/bulk' },
  popularStyles: { url: 'https://api.citation-api.com/2.1/rest/popular-styles' },
  styles: { url: 'https://api.citation-api.com/2.1/rest/styles' },
}, Config.apiKey)

const sourcePath = {
  article: Config.sourceArticleUrl,
  book: Config.sourceBookUrl,
  website: Config.sourceWebsiteUrl,
  newspaper: Config.sourceNewspaperUrl,
  journal: Config.sourceJournalUrl,
  magazine: Config.sourceMagazineUrl,
  film: Config.sourceFilmUrl,
  default: Config.sourceDefaultUrl,
}
export const sourceApi = new SourceApi(sourcePath, Config.autociteUrl, Config.autociteKey)



// WEBPACK FOOTER //
// ./src/configureApi.js